module App.Classes {
    export class AppointmentQuestion {
        id: number
        description: string
        code: string
        MakeId: string
        label: string
        notVisibleWhenWaiting: boolean
    }
}